import React, { useEffect } from 'react';
import { Badge, Collapse } from 'antd';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Icon, { MenuOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import QuickTurnPartStore from 'stores/QuickTurnPartStore';
import UserStore from 'stores/UserStore';
import { ReactComponent as QuickTurnIcon } from 'assets/svg/quickturn-icon.svg';
import { Price } from '@partsbadger/library';

interface Props {
    title: string;
}

const Menu = (props: Props) => {
    return (
        <div className="bg-white border-bottom mb-2">
            <div className="d-flex container h-100">
                <div className="d-sm-block d-md-none quickturn-mobile-header">
                    <Collapse expandIcon={() => <MenuOutlined />} ghost>
                        <Collapse.Panel
                            key={0}
                            header={
                                <div className="d-flex align-items-center mb-0">
                                    <h1 className="d-flex align-items-baseline mb-0 quickturn-menu-headline">
                                        {/* <Icon component={QuickTurnIcon} style={{ fontSize: '3rem', marginRight: '0.5rem' }} />  */}
                                        <span className="plus-jakarta-sans" style={{ fontWeight: 900 }}>
                                            QuickTurn
                                        </span>
                                        <span className="plus-jakarta-sans" style={{ fontWeight: 300 }}>
                                            |
                                        </span>
                                        <span style={{ fontWeight: 300 }}>{props.title}</span>
                                    </h1>
                                </div>
                            }
                            extra={
                                <Link
                                    to="/quick-turn/cart"
                                    className="d-flex align-items-center"
                                    style={{ columnGap: '0.8rem' }}
                                >
                                    <Badge count={QuickTurnPartStore.orderData?.line_items?.length} color="#c00">
                                        <ShoppingCartOutlined style={{ fontSize: '1.5rem' }} />
                                    </Badge>
                                </Link>
                            }
                        >
                            <div className="d-flex flex-column align-items-center">
                                <Link to="/quick-turn/design" className="d-flex mb-3">
                                    <div className="d-flex flex-row">
                                        {/* <Icon
                                            component={QuickTurnIcon}
                                            style={{ fontSize: '1.2rem', marginRight: '0.25rem' }}
                                        />{' '} */}
                                        <span className="font-size-base font-weight-normal">Part Designer</span>
                                    </div>
                                </Link>

                                <Link to="/quick-turn/order-history" className="d-flex">
                                    <div className="d-flex flex-column">
                                        <span className="font-size-base font-weight-normal">My Orders</span>
                                    </div>
                                </Link>
                            </div>
                        </Collapse.Panel>
                    </Collapse>
                </div>
                <div className="d-md-flex d-none w-100">
                    <div className="d-flex container h-100 p-0 pt-3 pb-3">
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center w-100">
                            <h1 className="d-flex align-items-baseline mb-0 quickturn-menu-headline">
                                <span className="plus-jakarta-sans" style={{ fontWeight: 900 }}>
                                    QuickTurn
                                </span>
                                <span className="plus-jakarta-sans" style={{ fontWeight: 300 }}>
                                    |
                                </span>
                                <span style={{ fontWeight: 300 }}>{props.title}</span>
                            </h1>
                            {/* <div className="d-flex flex-row align-items-center" style={{ columnGap: '2rem' }}>
                                <Link to="/quick-turn/design/bolt" className="d-flex" style={{ columnGap: '1rem' }}>
                                    <div className="d-flex flex-column">
                                        <span className="font-size-base font-weight-normal">Bolt Designer</span>
                                    </div>
                                </Link>

                                <Link to="/quick-turn/order-history" className="d-flex" style={{ columnGap: '1rem' }}>
                                    <div className="d-flex flex-column">
                                        <span className="font-size-base font-weight-normal">My Orders</span>
                                    </div>
                                </Link>

                                <Link
                                    to="/quick-turn/cart"
                                    className="d-flex align-items-center"
                                    style={{ columnGap: '0.8rem' }}
                                >
                                    <Badge count={QuickTurnPartStore.orderData?.line_items?.length} color="#c00">
                                        <ShoppingCartOutlined style={{ fontSize: '2rem' }} />
                                    </Badge>
                                    <div className="d-flex flex-column align-items-start">
                                        <span
                                            className="font-size-base font-weight-normal"
                                            style={{ lineHeight: '14px' }}
                                        >
                                            My Cart
                                        </span>

                                        <span className="font-size-md font-weight-base">
                                            <Price
                                                value={
                                                    QuickTurnPartStore?.orderData?.subtotal
                                                        ? QuickTurnPartStore?.orderData?.subtotal
                                                        : 0
                                                }
                                            />
                                        </span>
                                    </div>
                                </Link>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{
                    width: '100%',
                    background: '#245f24',
                    color: '#ffffff',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    lineHeight: '2rem',
                    fontStyle: 'italic',
                }}
            >
                Now Offering 2-Day Lead Times on Most Orders
            </div>
        </div>
    );
};

export default observer(Menu);
